import { c as _c } from "react/compiler-runtime";
import { showError } from 'components/notify';
import { useQuerySb } from 'utils/db/useQuerySb';
import { usePortal } from '../portal';
import { isEmpty } from 'remeda';
import { parseOrDefault } from 'shared/type';
import { notNull } from 'shared/type';
import { okOrThrow } from 'shared/promise';
import { Profile } from '../profileTypes';
import { showNotification } from '@mantine/notifications';
import { sb } from 'utils/db';
import { useMutation } from '@tanstack/react-query';
import { useMemo } from 'react';
import { zInvite, InviteStatus, Invite, InviteNew } from './inviteTypes';
import { UseAdminUsersList } from './AdminUsers';
import { Auth } from 'api/auth';
import { processNewInvites } from 'api/server/invites';

/** hook to use from the admin invite page */
export const useAdminInvites = t0 => {
  const $ = _c(17);
  const {
    uUsers
  } = t0;
  const {
    profile,
    workspace_id
  } = usePortal();
  let t1;
  let t2;
  if ($[0] !== workspace_id) {
    t1 = ["useInvite", {
      workspace_id
    }];
    t2 = async () => {
      const {
        data,
        error
      } = await sb.from("invite_latest").select("*").match({
        workspace_id
      }).not("status", "in", `(${["canceled", "profile", "removed"].join(",")})`).order("created_at", {
        ascending: false
      });
      if (error) {
        throw error;
      }
      return data.map(_temp).filter(notNull);
    };
    $[0] = workspace_id;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = profile?.workspace_id != null;
  let t4;
  if ($[3] !== t3) {
    t4 = {
      enabled: t3
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    data: invitesRaw,
    refetch
  } = useQuerySb("invite", t1, t2, t4);
  let t5;
  if ($[5] !== invitesRaw || $[6] !== uUsers.users) {
    t5 = invitesRaw?.filter(u => uUsers.users ? !uUsers.users.find(b => b.email == u.email) : true);
    $[5] = invitesRaw;
    $[6] = uUsers.users;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const invites = t5;
  let t6;
  if ($[8] !== refetch || $[9] !== workspace_id) {
    t6 = {
      mutationFn: async t7 => {
        const {
          newInvites
        } = t7;
        const sentInvites = await processNewInvites({
          sb,
          workspace_id,
          newInvites
        }).then(_temp2);
        if (isEmpty(sentInvites)) {
          return;
        }
        await Auth.sendInvites({
          ids: sentInvites.map(_temp3)
        }).then(okOrThrow);
        showNotification({
          message: "Invites processed - check invite list for status updates"
        });
        await refetch();
      },
      onError: _temp4
    };
    $[8] = refetch;
    $[9] = workspace_id;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const sendInvitesMute = useMutation(t6);
  let t7;
  if ($[11] !== refetch) {
    t7 = async id => {
      const {
        error: error_1
      } = await sb.from("invite").update({
        status: "canceled" as InviteStatus
      }).eq("id", id);
      if (error_1) {
        console.error("error cancelling invite", error_1);
      }
      await refetch();
    };
    $[11] = refetch;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const cancelInvite = t7;
  let t8;
  if ($[13] !== cancelInvite || $[14] !== invites || $[15] !== sendInvitesMute) {
    t8 = {
      invites,
      sendInvites: sendInvitesMute,
      cancelInvite
    };
    $[13] = cancelInvite;
    $[14] = invites;
    $[15] = sendInvitesMute;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
function _temp(d) {
  return parseOrDefault(zInvite, d, undefined, t0 => {
    const {
      error: error_0
    } = t0;
    return console.warn("invite parse error", {
      error: error_0.message,
      row: d
    });
  });
}
function _temp2(rs) {
  if (!rs.ok) {
    throw new Error(rs.message);
  }
  return rs;
}
function _temp3(i) {
  return i.id;
}
function _temp4(e) {
  showError(e, "error sending invites");
}